/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots, PresenceGroup } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import { PromptStarterListProvider } from '../../../contexts/PromptStarterListContext';
import type {
  PromptStarterListState,
  PromptStarterListSlots,
  PromptStarterListContextValue,
} from './PromptStarterList.types';

/**
 * Render the final JSX of PromptStarterList
 */
export const renderPromptStarterList_unstable = (
  state: PromptStarterListState,
  contextValue: PromptStarterListContextValue,
): JSXElement => {
  assertSlots<PromptStarterListSlots>(state);

  return (
    <PromptStarterListProvider value={contextValue}>
      <state.root>
        <PresenceGroup>
          <state.gridWrapper>{state.root.children}</state.gridWrapper>
        </PresenceGroup>
        {state.actions && <state.actions />}
        {state.expandButton && <state.expandButton />}
      </state.root>
    </PromptStarterListProvider>
  );
};
